import { useState, useEffect } from 'react';
import { detectBrand, clearBrandCache } from '../utils/brandDetection';

/**
 * Custom React hook for accessing the current brand configuration
 * Re-detects brand on navigation events (popstate, hashchange)
 * @returns {Object} Current brand configuration object
 */
export function useBrand() {
  const [brand, setBrand] = useState(() => detectBrand());

  useEffect(() => {
    // Handler for navigation events
    const handleNavigation = () => {
      clearBrandCache();
      const newBrand = detectBrand();
      setBrand(newBrand);
    };

    // Listen for browser navigation events
    window.addEventListener('popstate', handleNavigation);
    window.addEventListener('hashchange', handleNavigation);

    // Initial detection (in case brand changed since component mount)
    const currentBrand = detectBrand();
    if (currentBrand.id !== brand.id) {
      setBrand(currentBrand);
    }

    // Cleanup event listeners
    return () => {
      window.removeEventListener('popstate', handleNavigation);
      window.removeEventListener('hashchange', handleNavigation);
    };
  }, [brand.id]);

  return brand;
}
